import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import id from "./locales/id.json";
import ja from "./locales/ja.json";
// import ko from "./locales/ko.json";
import vi from "./locales/vi.json";
import zh from "./locales/zh.json";
import tw from "./locales/zh-tw.json"; //번체
// import mn from "./locales/mn.json";
import th from "./locales/th.json";
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();
let i18n_lang = cookies.get("i18n_redirected");
// console.log('i18n_lang',i18n_lang);

const messages = {
  en: en,
  // ko: ko,
  ja: ja,
  // id: id,
  vi: vi,
  zh: zh,
  tw: tw,
  // mn: mn,
  th: th,
};
const i18n = createI18n({
  locale: i18n_lang ? i18n_lang : "en", // set locale
  fallbackLocale: "en",
  messages, // set locale messages
});

i18n.translate = (key) => {
  return i18n.global.t(key);
};

export default i18n;
